    var colWidth = $(".blog_item").width();
    
    window.onresize = function () {
    var colWidth = $(".blog_item").width();
    };
    
    var $grid = $(".blog_mesonary").masonry({
    // options
    itemSelector: ".blog_item",
    columnWidth: ".blog_item",
    percentPosition: true,
    gutter: 0,
    fitWidth: true
  });


  // $(".blog_filter_flex li:first-child a").addClass('active');

  // $(".blog_filter_flex li a").click(function(){
  //   $(this).parent().siblings().find("a").removeClass('active')
  //   $(this).addClass('active');
  // });

function gridReload(){
    $grid.imagesLoaded().progress(function () {
    $grid.masonry("layout");
  });
}
gridReload();


// $( window).on("resize" , function() {
//  gridReload();
//   console.log("yes")
// });
